export const filterOption = (input, option) => {
	const { children } = option.props;
	return children.toLowerCase().includes(input.toLowerCase());
};
